import React, { useEffect, useState } from "react";
import { DMMMYYYY_formate, MyModal } from "../../../utility";
import { Doughnut } from "react-chartjs-2";
import { getJoinedRoICount, getAdsInvest } from "../../../apiServices";
import styles from "./JoinedRoi.module.scss";
import {
  FaFilter,
  FaHandshake,
  FaMoneyBill,
  FaRupeeSign,
} from "react-icons/fa";
import ModalContainer from "../../../components/modal_popup";
import {
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import googleLogo from "../../../assets/images/2a5758d6-4edb-4047-87bb-e6b94dbbbab0-cover.png";
import metaLogo from "../../../assets/images/images.png";

const formatDateDateset = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function JoinedRoiWithandWithout() {
  const formatDate = (date) => date.toISOString().split("T")[0];
  const formatAmount = (val) => `₹${Number(val).toLocaleString("en-IN")}`;

  const d = new Date();
  const startDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-01`;
  // const startDate = "2025-08-01";
  const endDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()}`;

  const [filterData, setFilterData] = useState({
    dateFilterType: "Current Month",
    startDate: startDate,
    endDate: endDate,
    leftCompany: 0,
  });

  const [appliedFilter, setAppliedFilter] = useState(null);

  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState([]);

  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const [googleInvest, setGoogleInvest] = useState(0);
  const [metaInvest, setMetaInvest] = useState(0);

  const [googleProfit, setGoogleProfit] = useState(0);
  const [metaProfit, setMetaProfit] = useState(0);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [showCustom, setshowCustom] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });

  useEffect(() => {
    fetchAllData();
  }, [startDate, endDate]); // ✅ date change triggers API

  const mergeCtcAndCount = (ctcData, countData) => {
    return ctcData.map((ctc) => {
      const countRow = countData.find((c) => c.admin_id === ctc.admin_id) || {};
      // console.log(countRow, "countRow");

      return {
        name: ctc.assign_to,
        googleAmount: Number(ctc.google_ads_ctc) || 0,
        googleCount: Number(countRow.google_ads_count) || 0,
        metaAmount: Number(ctc.meta_lead_ctc) || 0,
        metaCount: Number(countRow.meta_lead_count) || 0,
      };
    });
  };

  //   const fetchAllData = async () => {
  //     try {
  //       // 🔹 ROI DATA
  //       const roiRes = await getJoinedRoICount({
  //         fromDate: startDate,
  //         toDate: endDate,
  //         leftCompany: 0,
  //       });

  //       // 🔹 INVEST DATA
  //       const investRes = await getAdsInvest({
  //         fromDate: startDate,
  //         toDate: endDate,
  //       });

  //       if (roiRes.status && investRes.status) {
  //         const googleTotal = roiRes.data.reduce(
  //           (sum, item) => sum + Number(item.google_ads_ctc || 0),
  //           0
  //         );

  //         const metaTotal = roiRes.data.reduce(
  //           (sum, item) => sum + Number(item.meta_lead_ctc || 0),
  //           0
  //         );

  //         const googleInv = Number(investRes.data.googleInvest || 0);
  //         const metaInv = Number(investRes.data.metaInvest || 0);

  //         // ✅ SET INVEST
  //         setGoogleInvest(googleInv);
  //         setMetaInvest(metaInv);

  //         // ✅ PROFIT / LOSS
  //         setGoogleProfit(googleTotal - googleInv);
  //         setMetaProfit(metaTotal - metaInv);

  //         // ✅ PIE
  //         setChartData({
  //           labels: ["Google Ads", "Meta Ads"],
  //           datasets: [
  //             {
  //               data: [googleTotal, metaTotal],
  //               backgroundColor: ["#3d85c6", "#E65122"],
  //               hoverOffset: 4,
  //             },
  //           ],
  //         });

  //         setTableData(mergeCtcAndCount(roiRes.data, roiRes.Countdata));
  //       }
  //     } catch (error) {
  //       console.error("Fetch Error", error);
  //     }
  //   };

  const fetchAllData = async () => {
    setLoading(true);

    try {
      // ✅ BUILD PAYLOAD
      const payload = {
        fromDate: appliedFilter?.startDate
          ? appliedFilter.startDate
          // : "2025-08-01",
        : filterData.startDate,

        toDate: appliedFilter?.endDate
          ? appliedFilter.endDate
          : filterData.endDate,
      };

      // ✅ PASS leftCompany ONLY IF FILTER EXISTS & VALUE IS 0
      if (appliedFilter?.leftCompany === 0) {
        payload.leftCompany = 0;
      }

      // 🔹 ROI DATA
      const roiRes = await getJoinedRoICount(payload);

      // 🔹 INVEST DATA
      const investRes = await getAdsInvest(payload);

      if (!roiRes?.status || !investRes?.status) return;

      const roiData = roiRes.data || [];
      const countData = roiRes.Countdata || [];

      // 🔹 TOTALS
      const googleTotal = roiData.reduce(
        (sum, item) => sum + Number(item.google_ads_ctc || 0),
        0
      );

      const metaTotal = roiData.reduce(
        (sum, item) => sum + Number(item.meta_lead_ctc || 0),
        0
      );

      const googleInv = Number(investRes.data?.googleInvest || 0);
      const metaInv = Number(investRes.data?.metaInvest || 0);

      const isEmpty =
        roiData.length === 0 &&
        countData.length === 0 &&
        googleTotal === 0 &&
        metaTotal === 0;

      // 🔹 SET VALUES
      setGoogleInvest(googleInv);
      setMetaInvest(metaInv);

      setGoogleProfit(googleTotal - googleInv);
      setMetaProfit(metaTotal - metaInv);

      // 🔹 CHART & TABLE
      if (isEmpty) {
        setChartData({
          labels: ["No Data"],
          datasets: [
            {
              data: [1],
              backgroundColor: ["#D9D9D9"],
            },
          ],
        });
        setTableData([]);
      } else {
        setChartData({
          labels: ["Google Ads", "Meta Ads"],
          datasets: [
            {
              data: [googleTotal, metaTotal],
              backgroundColor: ["#3d85c6", "#E65122"],
            },
          ],
        });

        setTableData(mergeCtcAndCount(roiData, countData));
      }
    } catch (error) {
      console.error("Fetch Error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [appliedFilter]);

  const profitStyle = (value) => ({
    color: value >= 0 ? "#169c50" : "#E65122",
    fontWeight: "bold",
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        color: "white",
        font: {
          weight: "bold",
          size: 16,
        },
        formatter: (value, context) => {
          if (context.chart.data.labels[0] === "No Data") return "";
          return value < 10 ? `0${value}` : value;
        },
        display: (context) => context.chart.data.labels[0] !== "No Data",
      },
    },
    cutout: "60%",
    rotation: -Math.PI / 2,
  };
  function handleCustomDate(value, type) {
    const val = value.target.value;

    if (type === "startDate") {
      setFilterData((prev) => ({
        ...prev,
        startDate: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setFilterData((prev) => ({
        ...prev,
        endDate: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  }

  const isFormValid = () => {
    const isValid = filterData.startDate && filterData.endDate;

    if (!filterData.startDate) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!filterData.endDate) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };
  const handleApplyCustomDate = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      // console.log("Form submitted:", dateRange);
      setValidationErrors({
        start: false,
        end: false,
      });
      setshowCustom(false);
    }
  };
  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "lastMonth") {
      // ✅ Previous full month
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);

      setFilterData((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        startDate: formatDateDateset(startDate),
        endDate: formatDateDateset(endDate),
      }));
    } else if (val === "last3Month") {
      // ✅ Previous 3 full months
      startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);

      setFilterData((prev) => ({
        ...prev,
        dateFilterType: "Last 3 Months",
        startDate: formatDateDateset(startDate),
        endDate: formatDateDateset(endDate),
      }));
    } else if (val === "currentMonth") {
      // ✅ Current month only
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = today;

      setFilterData((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        startDate: formatDateDateset(startDate),
        endDate: formatDateDateset(endDate),
      }));
    } else if (val === "custom") {
      setshowCustom(true);
    }

    setAnchorEl(null);
  };

  const handleClose = (val) => {
    console.log(val);

    setAnchorEl(null);
  };

  return (
    <div className="container">
      <div className="row">
        {/* TABLE */}
        <div className="col-sm-5">
          <div className="text-center">
            <div
              className="d-inline-flex justify-content-center align-items-center text-center mb-2 gap-2 px-1 rounded"
              style={{ backgroundColor: "#169c50", color: "#fff" }}
            >
              <b>
                <DMMMYYYY_formate dateValue={filterData.startDate} />
              </b>{" "}
              to{" "}
              <b>
                <DMMMYYYY_formate dateValue={filterData.endDate} />
              </b>
            </div>
          </div>

          <div>
            <div className={styles.container}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th rowSpan={2} className={styles.stickyTh}>
                      Name
                    </th>
                    <th colSpan={2} className={styles.stickyThCenter}>
                      Google Ads
                    </th>
                    <th colSpan={2} className={styles.stickyThCenter}>
                      Meta Ads
                    </th>
                  </tr>
                  <tr>
                    <th className={styles.stickyTh}>Amount</th>
                    <th className={styles.stickyTh}>Count</th>
                    <th className={styles.stickyTh}>Amount</th>
                    <th className={styles.stickyTh}>Count</th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.length === 0 ? (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", color: "#832424ff" }}
                      >
                        No data available
                      </td>
                    </tr>
                  ) : (
                    tableData.map((row, i) => (
                      <tr key={i}>
                        <td className={styles.cell}>{row.name}</td>
                        <td className={styles.cell}>
                          {formatAmount(row.googleAmount)}
                        </td>
                        <td className={styles.cell}>{row.googleCount}</td>
                        <td className={styles.cell}>
                          {formatAmount(row.metaAmount)}
                        </td>
                        <td className={styles.cell}>{row.metaCount}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* PIE + INVEST */}
        <div className="col-sm-7">
          <div className="d-flex justify-content-end align-items-center b mt-4 gap-3">
            {/* <button onClick={fetchAllData} className="btn text-success">
              <BiRefresh className={loading ? styles.spin : ""} />
            </button> */}

            <button
              className="btn d-flex align-items-center gap-2"
              style={{ backgroundColor: "#169c50", color: "#fff" }}
              onClick={() => setOpenFilter(!openFilter)}
            >
              <FaFilter /> Filter
            </button>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div style={{ width: 350 }}>
              {chartData && <Doughnut data={chartData} options={options} />}
            </div>

            {/* <div className="ms-4">
              <p>
                <b>Google Invest:</b> {formatAmount(googleInvest)}
              </p>
              <p>
                <b>Google Profit:</b>{" "}
                <span style={profitStyle(googleProfit)}>
                  {googleProfit >= 0 ? "+" : ""}
                  {formatAmount(googleProfit)}
                </span>
              </p>

              <p>
                <b>Meta Invest:</b> {formatAmount(metaInvest)}
              </p>
              <p>
                <b>Meta Profit:</b>{" "}
                <span style={profitStyle(metaProfit)}>
                  {metaProfit >= 0 ? "+" : ""}
                  {formatAmount(metaProfit)}
                </span>
              </p>
            </div> */}
            <div className="d-flex flex-column gap-4 mt-3">
              {/* 🔹 GOOGLE BOX */}
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  padding: "16px",
                  minWidth: "220px",
                  background: "#f9fbff",
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <img src={googleLogo} alt="Google Ads" width={28} />
                  <b>Google Ads</b>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <span style={{ width: 70 }}>
                    <b>Invest</b>
                  </span>
                  <span className="mx-1">
                    <b>:</b>
                  </span>
                  <span>{formatAmount(googleInvest)}</span>
                </div>

                <div className="d-flex align-items-center">
                  <span style={{ width: 70 }}>
                    <b>Profit</b>
                  </span>
                  <span className="mx-1">
                    <b>:</b>
                  </span>
                  <span style={profitStyle(googleProfit)}>
                    {googleProfit >= 0 ? "+" : ""}
                    {formatAmount(googleProfit)}
                  </span>
                </div>
              </div>

              {/* 🔹 META BOX */}
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  padding: "16px",
                  minWidth: "220px",
                  background: "#fff7f4",
                }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <img src={metaLogo} alt="Meta Ads" width={28} />
                  <b>Meta Ads</b>
                </div>

                <div className="d-flex align-items-center mb-2">
                  <span style={{ width: "80px" }}>
                    <b>Invest</b>
                  </span>
                  <span className="mx-1">
                    <b>:</b>
                  </span>
                  <span>{formatAmount(metaInvest)}</span>
                </div>

                <div className="d-flex align-items-center">
                  <span style={{ width: "80px" }}>
                    <b>Profit</b>
                  </span>
                  <span className="mx-1">
                    <b>:</b>
                  </span>
                  <span style={profitStyle(metaProfit)}>
                    {metaProfit >= 0 ? "+" : ""}
                    {formatAmount(metaProfit)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openFilter && (
        <>
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div className="p-1" style={{ width: "400px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <b>Filter</b>
                      <button
                        className="btn btn-danger"
                        onClick={() => setOpenFilter(!openFilter)}
                      >
                        <AiOutlineClose />
                      </button>
                    </div>

                    <div>
                      <FormControl variant="outlined" fullWidth>
                        <TextField
                          label="ROI Date Filter"
                          id="basic-button"
                          value={`${filterData.dateFilterType}`}
                          // value={`${dateRange.start} - ${dateRange.end}`}
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                        ></TextField>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          fullWidth
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          style={{ width: "100%" }}
                        >
                          <MenuItem
                            onClick={() => {
                              handleDateSelect("currentMonth");
                            }}
                          >
                            Current Month
                          </MenuItem>

                          <MenuItem
                            onClick={() => {
                              handleDateSelect("lastMonth");
                            }}
                          >
                            Last Month
                          </MenuItem>

                          <MenuItem
                            onClick={() => {
                              handleDateSelect("last3Month");
                            }}
                          >
                            Last 3 Month
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleDateSelect("custom");
                            }}
                          >
                            Custom Date
                          </MenuItem>
                        </Menu>
                      </FormControl>
                      {showCustom && (
                        <MyModal>
                          <ModalContainer
                            zIndex={1005}
                            childComponent={
                              <div
                                style={{
                                  minWidth: "400px",
                                  width: "auto",
                                }}
                              >
                                <>
                                  <div>
                                    <form>
                                      <p className="text-center ">
                                        Select Custom Date{" "}
                                      </p>
                                      <div className="mt-2">
                                        <label htmlFor="start">From</label>
                                        <input
                                          className={`form-control ${
                                            validationErrors.start
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          style={{ width: "100%" }}
                                          type="date"
                                          id="start"
                                          onChange={(value) =>
                                            handleCustomDate(value, "startDate")
                                          }
                                          value={filterData.startDate}
                                          name="trip-start"
                                          min="2020-01-01"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                        />
                                        {validationErrors.start && (
                                          <div className="invalid-feedback">
                                            Start date is required.
                                          </div>
                                        )}
                                      </div>
                                      <div className="mt-2">
                                        <label htmlFor="end">To</label>
                                        <input
                                          className={`form-control ${
                                            validationErrors.end
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          value={filterData.endDate}
                                          style={{ width: "100%" }}
                                          type="date"
                                          id="end"
                                          onChange={(value) =>
                                            handleCustomDate(value, "endDate")
                                          }
                                          name="trip-end"
                                          min="2020-01-01"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                        />
                                        {validationErrors.end && (
                                          <div className="invalid-feedback">
                                            End date is required.
                                          </div>
                                        )}
                                      </div>
                                      <div className="d-flex justify-content-end mt-3 ">
                                        <button
                                          onClick={() => {
                                            setValidationErrors({
                                              start: false,
                                              end: false,
                                            });
                                            setshowCustom(false);
                                          }}
                                          style={{
                                            backgroundColor: "#b2261c",
                                          }}
                                          className="btn rounded-pill text-white px-4  me-2"
                                        >
                                          Close
                                        </button>
                                        <button
                                          onClick={handleApplyCustomDate}
                                          // color="primary"
                                          className="btn rounded-pill text-white px-4"
                                          style={{
                                            backgroundColor: "#169C50",
                                          }}
                                        >
                                          Apply
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </>
                              </div>
                            }
                          />
                        </MyModal>
                      )}
                    </div>
                    <div className="mt-3">
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="left-status-label">
                          Left Status
                        </InputLabel>

                        <Select
                          labelId="left-status-label"
                          id="left-status"
                          value={filterData.leftCompany}
                          label="Left Status"
                          onChange={(e) =>
                            setFilterData((prev) => ({
                              ...prev,
                              leftCompany: e.target.value,
                            }))
                          }
                        >
                          <MenuItem value="with">With Left</MenuItem>

                          <MenuItem value={0}>Without Left</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-4">
                      <button
                        className="btn btn-danger "
                        onClick={() => {
                          setFilterData((prev) => ({
                            ...prev,
                            startDate: startDate,
                            endDate: endDate,
                            dateFilterType: "Current Month",
                            leftCompany: "",
                          }));
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => {
                          setAppliedFilter({
                            startDate: filterData.startDate,
                            endDate: filterData.endDate,
                            leftCompany: filterData.leftCompany,
                          });
                          setOpenFilter(false);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
    </div>
  );
}

export default JoinedRoiWithandWithout;
